export const requirementStatusColor = (status_id) => {
  switch(status_id) {
    case 1: return "color: #F99A91;"; // $color_not_started
    case 2: return "color: #ECD374;"; // $color_in_progess
    case 3: return "color: #399ADB;"; // $color_delayed
    case 4: return "color: #18B358;"; // $color_completed
    case 7: return "color: #AB4FD2;"; // $color_not_applicable
    case 8: return "color: #878383;"; // $color_exempt
    default: return "color: #f0f0f0;";
  }
}

export const requirementAppreciationColor = (appreciation_id) => {
  switch(appreciation_id) {
    case 6:  return "color: #18B358;"; // $color_conforme
    case 7:  return "color: #F99A91;"; // $color_non_conforme
    case 8:  return "color: #878383;"; // $color_non_applicable
    case 24: return "color: #ab4fd2;"; // $color_non_evalue
    case 31: return "color: #ECD374;"; // $color_revue_preliminaire
    default: return "color: #f0f0f0;";
  }
}
